import React from 'react';
import PropTypes from 'prop-types';
import { Table, Icon, IconButton } from 'rsuite';

const { Cell } = Table;
export const DeleteCell = ({
  onDelete,
  isUpdating,
  isDeleting,
  rowData,
  ...props
}) => {
  const disabledAction = isDeleting(rowData) || isUpdating(rowData);
  const handleOnDelete = () => {
    if (disabledAction) return;
    onDelete(rowData);
  };

  return (
    <Cell {...props} className="link-group">
      <IconButton
        disabled={disabledAction}
        icon={<Icon icon="trash" />}
        color="red"
        appearance="ghost"
        onClick={handleOnDelete}
      />
    </Cell>
  );
};

DeleteCell.propTypes = {
  onDelete: PropTypes.func.isRequired,
  isUpdating: PropTypes.func.isRequired,
  isDeleting: PropTypes.func.isRequired,
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({})
};

DeleteCell.defaultProps = {
  rowData: null
};

export default DeleteCell;
